class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.fetchRecommendations();
  }

  fetchRecommendations() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
  
      observer.unobserve(this);
  
      const url = this.getAttribute('data-url');
  
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);